const ADD_GRID_OBJECTS = 'ADD_GRID_OBJECTS';
export const CLEAR_GRID = 'CLEAR_GRID';

const INITIAL_STATE = {
  objects: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_GRID_OBJECTS:
      return {
        objects: [...action.payload],
      };
    case CLEAR_GRID:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function setGridObjects(objects) {
  return {
    type: ADD_GRID_OBJECTS,
    payload: objects,
  };
}
